/** @jsxImportSource theme-ui */
export * from "../components/iconsV2/output";
